module.exports = __webpack_public_path__ + "media/images/logo_p3-fd8d376699a21ee451dd9f2390b3ae4c.svg";